import { Alert, Box, Button, Dialog, DialogContent, Grid, Snackbar, Stack, ToggleButton, ToggleButtonGroup, Typography, useMediaQuery } from "@mui/material";
import WhiteInosio from "../../../icons/whiteinosio.svg";
import BackIcon from '../../../icons/back1.svg'
import { convertCentsToDollars } from "../../util/converters";
import { useDispatch } from "react-redux";
import React from "react";
import { approvedISOStandards } from "../../util/approvedISOStandards";
import AddBankIcon from "../../../icons/AddBankIcon.png";
import BankInputBox from "../../BankInput";
import { CreateBankAccountDTO } from "@inosio/payments-sdk";
import { BankRoutingNumberRegex, NumberRegex } from "../../../utils/regex";
import AddBankBgImage from "../../../icons/addBankBgImage.png";
import { getBuildBankAccount, getResetBuildBankAccount } from "../../../pmui/paymentrequests/sagas/paymentrequestslice";
import NumberFormat from "react-number-format";

interface AddBankAccountModalProps {
    open: boolean;
    onContinue: () => void;
    onBackClick: () => void;
    Fees: number;
    CompanyName: string;
}
const AddBankAccountModal = (props: AddBankAccountModalProps) => {
    const { open, onContinue, onBackClick, Fees, CompanyName } = props
    const isOnMobileScreen = useMediaQuery("(max-width:600px)");
    const matches380 = useMediaQuery("(max-width:380px)");
    const dispatch = useDispatch();
    const [snackBarOpen, setSnackBarOpen] = React.useState(false);
    const [checkingActive, setCheckingActive] = React.useState(true);
    const [savingActive, setSavingActive] = React.useState(false);
    const [bankName, setBankName] = React.useState("");
    const [bankHolderName, setBankHolderName] = React.useState("");
    const [bankAccountNumber, setBankAccountNumber] = React.useState("");
    const [bankRoutingNumber, setBankRoutingNumber] = React.useState("");
    const [bankNickName, setBankNickName] = React.useState("");
    const [bankNameError, setBankNameError] = React.useState("");
    const [bankHolderNameError, setBankHolderNameError] = React.useState("");
    const [bankAccountNumberError, setBankAccountNumberError] = React.useState("");
    const [bankRoutingNumberError, setBankRoutingNumberError] = React.useState("");
    const [bankGlobalError, setBankGlobalError] = React.useState<string | null>(null);
    const [bankCountry, setBankCountry] = React.useState("US");
    const [bankAddress, setBankAddress] = React.useState("");
    const [bankCity, setBankCity] = React.useState("");
    const [bankState, setBankState] = React.useState("");
    const [bankZip, setBankZip] = React.useState("");
    const [bankAddressError, setBankAddressError] = React.useState("");
    const [bankZipError, setBankZipError] = React.useState("");
    const [bankCountryError, setBankCountryError] = React.useState("");
    const [bankCityError, setBankCityError] = React.useState("");
    const [bankStateError, setBankStateError] = React.useState("");
    const { Countries: approvedCountries, States: approvedStates, Provinces: approvedProvinces } = approvedISOStandards;


    const setOnClick = () => {
        onBackClick()
        setBankName('')
        setBankHolderName('')
        setBankAccountNumber('')
        setBankRoutingNumber('')
        setBankNickName('')
        setBankNameError('')
        setBankHolderNameError('')
        setBankAccountNumberError('')
        setBankRoutingNumberError('')
        setBankGlobalError('')
        setBankAddress('')
        setBankCity('')
        setBankZip('')
        setBankAddressError('')
        setBankZipError('')
        setBankCountryError('')
        setBankCityError('')
        setBankStateError('')
        dispatch({
            type: getResetBuildBankAccount.type,
        });
    }


    const handleAlertClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackBarOpen(false);
    };

    const style = {
        height: isOnMobileScreen ? "100%" : "523px",
    };

    const validateBankAddress = () => {
        if (bankAddress.length === 0) {
            setBankAddressError("Bank address is empty!");
            return false;
        } else {
            setBankAddressError("");
            return true;
        }
    };
    const validateBankZip = () => {
        if (bankZip.length === 0) {
            setBankZipError("Bank ZIP code is empty!");
            return false;
        } else {
            setBankZipError("");
            return true;
        }
    };
    const validateBankCountry = () => {
        if (bankCountry.length === 0) {
            setBankCountryError("Bank country is empty!");
            return false;
        } else {
            setBankCountryError("");
            return true;
        }
    };
    const validateBankCity = () => {
        if (bankCity.length === 0) {
            setBankCityError("Bank city is empty!");
            return false;
        } else {
            setBankCityError("");
            return true;
        }
    };
    const validateBankState = () => {
        if (bankState.length === 0) {
            setBankStateError("Bank state is empty!");
            return false;
        } else {
            setBankStateError("");
            return true;
        }
    };
    const validateBankName = () => {
        if (bankName.length === 0) {
            setBankNameError("Bank name is empty!");
            return false;
        } else {
            setBankNameError("");
            return true;
        }
    };
    const validateBankHolderName = () => {
        if (bankHolderName.length === 0) {
            setBankHolderNameError("Bank holder name is empty!");
            return false;
        } else {
            setBankHolderNameError("");
            return true;
        }
    };
    const validateBankAccountNumber = () => {
        if (bankAccountNumber.length === 0) {
            setBankAccountNumberError("Bank account number is empty!");
            return false;
        } else {
            setBankAccountNumberError("");
            return true;
        }
    };
    const validateBankRoutingNumber = () => {
        if (bankRoutingNumber.length === 0) {
            setBankRoutingNumberError("Bank routing number is empty!");
            return false;
        } else if (bankRoutingNumber.length !== 9) {
            setBankRoutingNumberError("Routing number must be exactly 9 digits.");
            setBankGlobalError("Routing number must be exactly 9 digits")
            setSnackBarOpen(true);
            return false;
        } else if (!BankRoutingNumberRegex.test(bankRoutingNumber)) {
            setBankRoutingNumberError("Routing number must start with a 0, 1, 2 or 3.");
            setBankGlobalError("Routing number must start with a 0, 1, 2 or 3.");
            setSnackBarOpen(true);
            return false;
        } else {
            setBankRoutingNumberError("");
            setBankGlobalError("");
            return true;
        }
    };
    const onChangeAccountNumberHandler = (e: any) => {
        if (e.target.value === "" || NumberRegex.test(e.target.value)) {
            setBankAccountNumber(e.target.value);
        }
    };
    const onChangeRoutingNumberHandler = (e: any) => {
        if (e.target.value === "" || NumberRegex.test(e.target.value)) {
            setBankRoutingNumber(e.target.value);
        }
    };

    const [alignment, setAlignment] = React.useState("checking");

    const handleChange = (event: React.MouseEvent<HTMLElement>, newAlignment: string) => {
        setAlignment(newAlignment);
    };

    const handleAddBankSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const names = bankHolderName.split(" ");
        if (validateBankName() && validateBankHolderName() && validateBankAccountNumber() && validateBankRoutingNumber() && validateBankAddress() && validateBankCity() && validateBankState() && validateBankZip() && validateBankCountry()) {
            dispatch({
                type: getBuildBankAccount.type,
                payload: {
                    //Savings: S, checkings: C
                    AccountType: checkingActive ? "C" : "S",
                    AccountNumber: bankAccountNumber,
                    RoutingNumber: bankRoutingNumber,
                    BillingAddress: {
                        City: bankCity,
                        State: bankState,
                        Zip: bankZip,
                        Line1: bankAddress,
                        Country: bankCountry,
                    },
                    AccountHolderFirstname: names[0],
                    AccountHolderLastname: names[1],
                    NickName: bankNickName,
                    BankName: bankName,
                } as CreateBankAccountDTO,
            });
            onContinue()
        }
    };

    return (
        <Dialog
            open={open}
            fullScreen={isOnMobileScreen}
            BackdropProps={{
                invisible: true,
            }}
            fullWidth={true}
            disableEnforceFocus
            style={{
                background: "none",
            }}
            PaperProps={{
                style: {
                    pointerEvents: "auto",
                    borderRadius: isOnMobileScreen ? "0px" : "24px",
                    width: isOnMobileScreen ? "100%" : "472px",
                    boxShadow: "none",
                    overflow: "hidden"
                },
            }}
            disableEscapeKeyDown={true}
        >
            <DialogContent>
                <Box sx={style}>
                    <Grid container display="flex" flexDirection="column">
                        {isOnMobileScreen ?
                            <Grid item display='flex' justifyContent='center'>
                                <Grid item display='flex' pl={4} sx={{ width: '340px' }}>
                                    <img src={WhiteInosio} style={{ width: "75px", height: "75px" }} alt="logo" />
                                    <Typography
                                        sx={{
                                            fontFamily: "Work Sans",
                                            fontStyle: 'normal',
                                            fontWeight: 700,
                                            fontSize: '18px',
                                            lineHeight: '23px',
                                            color: '#14142B',
                                            textAlign: 'left',
                                            padding: '15px'
                                        }}>
                                        {CompanyName}
                                    </Typography>
                                </Grid>
                            </Grid>
                            : <></>}
                        <Typography sx={{
                            fontFamily: "Work Sans",
                            fontStyle: 'normal',
                            fontWeight: 700,
                            fontSize: '18px',
                            lineHeight: '23px',
                            color: '#14142B',
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '20px',
                            marginRight: isOnMobileScreen ? '10px' : '',
                        }}>
                            Add Bank Account
                        </Typography>
                        <Stack direction="column" justifyContent="start" alignItems="center" mt={isOnMobileScreen ? 1 : 0}>
                            <Stack
                                direction="column"
                                spacing={2}
                                style={{
                                    backgroundImage: "url(" + AddBankBgImage + ")",
                                    backgroundRepeat: "no-repeat",
                                    backgroundSize: matches380 ? "calc( 100% - 5px) 211px": "345px 211px",
                                    height: "210px",
                                    width: matches380 ? "100%": "350px",
                                    padding: "16px",
                                    marginRight: isOnMobileScreen ? "0px" : '-40px'

                                }}
                            >
                                <Stack direction="row" alignItems="center" spacing={25}>
                                    <div>
                                        <Typography
                                            style={{
                                                fontFamily: "'Open Sans', sans-serif",
                                                fontStyle: "normal",
                                                fontWeight: 600,
                                                fontSize: "14px",
                                                lineHeight: " 13px",
                                                textTransform: "capitalize",
                                                color: "#14142B",
                                            }}
                                        >
                                            Bank account
                                        </Typography>
                                    </div>
                                    <div>
                                        <img src={AddBankIcon} alt="card" style={{ width: "16px", height: "15px" }} />
                                    </div>
                                </Stack>
                                <div style={{ marginBottom: "5px" }}>
                                    <BankInputBox label="Bank Name" style={{ width: "220px" }} name="bank-name" placeholder="" value={bankName} onChange={(e: any) => setBankName(e.target.value)} autoComplete="bank-name" error={bankNameError} />
                                </div>
                                <div style={{ marginBottom: "5px" }}>
                                    <BankInputBox
                                        label="Name of account holder"
                                        style={{ width: "220px" }}
                                        placeholder=""
                                        name="bank-holder"
                                        value={bankHolderName}
                                        onChange={(e: any) => setBankHolderName(e.target.value)}
                                        autoComplete="bank-holder"
                                        error={bankHolderNameError}
                                    />
                                </div>
                                <Stack direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={1}>
                                    <div style={{ marginBottom: "5px" }}>
                                        <BankInputBox
                                            label="Account Number"
                                            style={{ width: "137px" }}
                                            placeholder=""
                                            name="account-number"
                                            value={bankAccountNumber}
                                            onChange={onChangeAccountNumberHandler}
                                            autoComplete="account-number"
                                            error={bankAccountNumberError}
                                        />
                                    </div>
                                    <div style={{ marginBottom: "5px" }}>
                                        <BankInputBox
                                            label="Routing Number"
                                            style={{ width: "137px" }}
                                            placeholder=""
                                            name="routing-number"
                                            value={bankRoutingNumber}
                                            onChange={onChangeRoutingNumberHandler}
                                            autoComplete="routing-number"
                                            error={bankRoutingNumberError}
                                        />
                                    </div>
                                </Stack>
                            </Stack>
                            <Stack
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                                spacing={1.8}
                                style={{
                                    marginBottom: "10px",
                                    marginRight: isOnMobileScreen ? "35px" : '0px'
                                }}
                            >
                                <input
                                    placeholder="Nick name"
                                    style={{
                                        border: "1px solid #F1F0F5",
                                        fontFamily: "'Open Sans', sans-serif",
                                        borderRadius: "24px",
                                        height: "15px",
                                        width: matches380 ? "50%": "180px",
                                        padding: "10px",

                                    }}
                                    name="nickname"
                                    type="text"
                                    value={bankNickName}
                                    onChange={(e) => setBankNickName(e.target.value)}
                                    autoComplete="nickname"
                                />
                                <ToggleButtonGroup color="primary" value={alignment} exclusive onChange={handleChange} style={{ width: isOnMobileScreen ? "155px" : "170px" }}>
                                    <ToggleButton
                                        value="checking"
                                        style={{
                                            fontFamily: "'Work Sans', sans-serif",
                                            width: "50%",
                                            border: "1px solid #39A2DB",
                                            borderRadius: "24px 0 0 24px ",
                                            background: checkingActive ? "#39A2DB" : "#fff",
                                            color: checkingActive ? "#fff" : "#39A2DB",
                                            textTransform: "capitalize",
                                            fontSize: "12px",
                                            lineHeight: "22px",
                                            padding: "5px 10px",
                                            height: "36px",
                                        }}
                                        size="small"
                                        onClick={() => {
                                            setCheckingActive(true);
                                            setSavingActive(false);
                                        }}
                                    >
                                        Checking
                                    </ToggleButton>
                                    <ToggleButton
                                        value="savings"
                                        style={{
                                            width: "50%",
                                            fontFamily: "'Work Sans', sans-serif",
                                            border: "1px solid #39A2DB",
                                            borderRadius: "0 24px  24px 0 ",
                                            background: savingActive ? "#39A2DB" : "#fff",
                                            color: savingActive ? "#fff" : "#39A2DB",
                                            textTransform: "capitalize",
                                            fontSize: "12px",
                                            lineHeight: "22px",
                                            padding: "5px 10px",
                                            height: "36px",
                                        }}
                                        size="small"
                                        onClick={() => {
                                            setCheckingActive(false);
                                            setSavingActive(true);
                                        }}
                                    >
                                        Savings
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Stack>

                            <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} style={{ marginBottom: "10px" }}>
                                <input
                                    placeholder="Address"
                                    style={{
                                        border: "1px solid #F1F0F5",
                                        borderRadius: "24px",
                                        height: "34px",
                                        width: matches380 ? "100%": "365px",
                                        margin: "0 auto",
                                        padding: "0 10px",
                                        borderTop: bankAddressError.length ? "2px  solid #DB3939" : "1px solid #F1F0F5",
                                        marginLeft: isOnMobileScreen ? "-40px" : "-2px",
                                    }}
                                    value={bankAddress}
                                    onChange={(e) => setBankAddress(e.target.value)}
                                    type="text"
                                    name="address"
                                />
                            </Stack>
                            <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} style={{ marginBottom: "10px", marginLeft: isOnMobileScreen ? "-40px" : "0px" }}>
                                <input
                                    placeholder="City"
                                    name="city"
                                    type="text"
                                    style={{
                                        border: "1px solid #F1F0F5",
                                        borderRadius: "24px",
                                        height: "3px",
                                        width: matches380 ? "50%": "170px",
                                        padding: "15px",
                                        borderTop: bankCityError.length ? "2px  solid #DB3939" : "1px solid #F1F0F5",
                                    }}
                                    value={bankCity}
                                    onChange={(e) => setBankCity(e.target.value)}
                                />
                                <div placeholder="State">
                                    <select
                                        placeholder="State"
                                        name='state'
                                        style={{
                                            border: "1px solid #F1F0F5",
                                            borderRadius: "24px",
                                            height: "36px",
                                            width: matches380 ? "100%": "170px",
                                            padding: "0 15px",
                                            borderTop: bankStateError.length ? "2px  solid #DB3939" : "1px solid #F1F0F5",
                                        }}
                                        defaultValue={bankState}
                                        onChange={(e) => setBankState(e.target.value)}
                                    >
                                        <option style={{ height: "36px" }} value=''>
                                            {`Select State`}
                                        </option>
                                        {bankCountry === "US" ? (
                                            approvedStates.map((stateRecord) => (
                                                <option style={{ height: "36px" }} key={stateRecord.Code} value={stateRecord.Code}>
                                                    {stateRecord.State + " - " + stateRecord.Code}
                                                </option>
                                            ))
                                        ) : bankCountry === "CA" ? (
                                            approvedProvinces.map((provinceRecord) => (
                                                <option style={{ height: "36px" }} key={provinceRecord.Code} value={provinceRecord.Code}>
                                                    {provinceRecord.Province + " - " + provinceRecord.Code}
                                                </option>
                                            ))
                                        ) : (
                                            <option style={{ height: "36px" }} value="NA">
                                                other
                                            </option>
                                        )}
                                    </select>
                                </div>
                            </Stack>
                            <Stack direction="row" justifyContent="center" alignItems="center" spacing={2} style={{ marginBottom: "20px", marginLeft: isOnMobileScreen ? "-40px" : "0px" }}>
                                <input
                                    placeholder="ZIP"
                                    style={{
                                        border: "1px solid #F1F0F5",
                                        borderRadius: "24px",
                                        height: "32px",
                                        width: matches380 ? "50%": "170px",
                                        padding: "0 15px",
                                        borderTop: bankZipError.length ? "2px  solid #DB3939" : "1px solid #F1F0F5",
                                    }}
                                    name="zip"
                                    type="text"
                                    value={bankZip}
                                    onChange={(e) => setBankZip(e.target.value)}
                                />
                                <div placeholder="Country">
                                    <select
                                        placeholder="Country"
                                        name='country'
                                        style={{
                                            border: "1px solid #F1F0F5",
                                            borderRadius: "24px",
                                            height: "36px",
                                            width: matches380 ? "100%": "170px",
                                            padding: "0 15px",
                                            borderTop: bankCountryError.length ? "2px  solid #DB3939" : "1px solid #F1F0F5",
                                        }}
                                        defaultValue="US"
                                        onChange={(e) => {
                                            setBankCountry(e.target.value);
                                            setBankState('');
                                        }}
                                    >
                                        {approvedCountries.map((countryRecord) => (
                                            <option style={{ height: "36px" }} key={countryRecord.Code} value={countryRecord.Code}>
                                                {countryRecord.Country + " - " + countryRecord.Code}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </Stack>
                            <Grid container rowSpacing={2} >
                                <Grid item sm={9}>
                                    {Fees !== 0 ?
                                        <Grid item ml={1.5} display='flex' alignItems='center' >
                                            <Typography
                                                style={{ fontSize: "16px", marginRight: '8px' }}>
                                                fee:
                                            </Typography>
                                            <NumberFormat
                                                thousandsGroupStyle="thousand"
                                                value={convertCentsToDollars(Fees)}
                                                prefix="$"
                                                decimalSeparator="."
                                                displayType="text"
                                                type="text"
                                                thousandSeparator={true}
                                                allowNegative={true}
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                            />
                                        </Grid>
                                        :
                                        <></>}
                                </Grid>
                                <Grid item xs={12} sm={3} sx={{ display: 'flex', justifyContent: 'center' }} mr={isOnMobileScreen ? 4 : 0} >
                                    <Button
                                        style={{
                                            borderRadius: "24px",
                                            textTransform: "capitalize",
                                            color: "white",
                                            backgroundColor: "#39A2DB",
                                            borderColor: "#39A2DB",
                                            height: '49',
                                            width: isOnMobileScreen ? '300px' : '99px'
                                        }}
                                        variant="contained"
                                        id="add-bank-btn"
                                        onClick={(e: any) => { handleAddBankSubmit(e) }}>
                                        Continue
                                    </Button>
                                </Grid>
                            </Grid>
                        </Stack>
                    </Grid>
                </Box>
                <Grid item sx={{ position: 'absolute', top: isOnMobileScreen ? 112 : 40, left: 15 }}>
                    <img src={BackIcon} alt="back" style={{ cursor: 'pointer' }} onClick={() => {
                        setOnClick()
                    }} />
                </Grid>
            </DialogContent >
            <Snackbar anchorOrigin={{ horizontal: 'center', vertical: 'top' }} open={snackBarOpen} autoHideDuration={4000} onClose={handleAlertClose}>
                <Alert onClose={handleAlertClose} severity="error">
                    {bankGlobalError}
                </Alert>
            </Snackbar>
        </Dialog >
    );
}

export default AddBankAccountModal;
